import React from 'react';
import Modal, { ModalProps } from 'rsuite/lib/Modal';
import { ButtonPrimary } from '../../../../../components';
import { LoadingSpinerArea } from '../../../../../components/LoadingSpinner';
import { SaveFiltersState } from '../../../../../reducers/ipa/priceManager/modals/saveFilters';
import './style.scss';

export type ExcluirFiltroModalProps = Omit<ModalProps, 'onHide'> & {
  onConfirm?: (id: string) => void;
  onHide?: () => void;
  saveFilter: Pick<SaveFiltersState, 'data' | 'name'>;
};

export const ExcluirFiltroModal = ({ className = '', saveFilter: { data, name }, onConfirm, onHide, ...props }: ExcluirFiltroModalProps) => {
  return (
    <Modal className={['info-modal', 'modal-excluir-filtros', className].join(' ')} onHide={onHide} {...props}>
      <form onSubmit={e => e.preventDefault()}>
        <Modal.Header>
          <Modal.Title className="font-size-200-semibold">
            <h2 className="font-size-400-semibold">Excluir filtro salvo?</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="font-size-100-regular">
            Tem certeza que deseja excluir o filtro <strong>{name}</strong>
            ?
            <br />O filtro será excluído permanentemente
          </p>
        </Modal.Body>
        <Modal.Footer>
          <ButtonPrimary skin="blue" theme="ghost" type="button" onClick={onHide}>
            CANCELAR
          </ButtonPrimary>
          <ButtonPrimary skin="blue" theme="filled" onClick={() => onConfirm?.(data?.value ?? '')} type="submit" autoFocus>
            EXCLUIR
          </ButtonPrimary>
        </Modal.Footer>
      </form>
      <LoadingSpinerArea size="sm" area="saved-filter" height={null} />
    </Modal>
  );
};
